import React from 'react';

const CompareTableTitle = function(props) {
  const {
          compareOffers,
          label,
        } = props;

  return (
    <tbody className={'table_title'}>
    <tr>
      <td colSpan={compareOffers.length + 2}>
        <div className={'title_wrapper'}>{label}</div>
      </td>
    </tr>
    </tbody>
  );
};

export default CompareTableTitle;